import {CONSTANTS} from '@/constants'

export default function(h, row, index) {
    let _time_d = ''
    let _time_t = ''
    if (row.wakeup_at !== null && row.wakeup_at) {
        _time_d = row.wakeup_at.substring(0, 10);
        _time_t = row.wakeup_at.substring(11, 16);
    }

    if (row.timestatus === 1)
        return <span class="alert-danger">{_time_d}<sup>{_time_t}</sup></span>
    else
    if (row.timestatus === 3)
        return <span class="alert-secondary">{_time_d}<sup>{_time_t}</sup></span>
    else
        return <span>{_time_d}<sup>{_time_t}</sup></span>


}